import React from 'react';
import { motion } from 'framer-motion';
import { Gift, BookOpen, Calendar, Gamepad2 } from 'lucide-react';
const bonuses = [{
  icon: <BookOpen className="w-8 h-8 text-gold" data-id="element-11" />,
  title: 'Guía de Ejercicios Tácticos',
  description: 'Más de 50 ejercicios específicos para resolver situaciones reales de partido.',
  value: '$15.000'
}, {
  icon: <Calendar className="w-8 h-8 text-gold" data-id="element-12" />,
  title: 'Plantilla de Planificación Semanal',
  description: 'El formato exacto para organizar tus microciclos sin perder tiempo.',
  value: '$10.000'
}, {
  icon: <Gamepad2 className="w-8 h-8 text-gold" data-id="element-13" />,
  title: 'Entrenamientos Divertidos que Enganchan a tus Jugadores',
  description: 'Ejercicios dinámicos, juegos aplicados al futsal y cómo generar ideas con IA para mejorar la experiencia del equipo.',
  value: '$20.000'
}];
export function Bonuses() {
  return <section className="py-12 px-4 bg-gradient-to-b from-[#0a0a1a] to-gray-900 border-t border-gray-800" data-id="element-14">
      <div className="max-w-5xl mx-auto" data-id="element-15">
        <div className="text-center mb-8" data-id="element-16">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-red-600 text-white px-5 py-2 rounded-full font-bold text-base mb-4 shadow-[0_0_15px_rgba(220,38,38,0.5)] animate-pulse" data-id="element-17">
            <Gift className="w-5 h-5" data-id="element-18" />
            GRATIS POR EL DÍA DE HOY
          </motion.div>
          <h2 className="text-2xl md:text-4xl font-black text-white mb-2" data-id="element-19">
            Bonos Exclusivos
          </h2>
          <p className="text-base text-gray-400" data-id="element-20">
            Llevate estas herramientas adicionales sin costo extra si comprás
            hoy.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4" data-id="element-21">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-gray-800/50 border border-gold/30 rounded-xl p-5 relative overflow-hidden group hover:bg-gray-800 transition-colors flex flex-col" data-id="element-22">
              <div className="absolute top-0 right-0 bg-gold text-black text-[10px] font-bold px-2 py-0.5 rounded-bl-lg" data-id="element-23">
                BONO #{index + 1}
              </div>
              <div className="mb-4 bg-gray-900 w-14 h-14 rounded-full flex items-center justify-center border border-gray-700 group-hover:border-gold/50 transition-colors" data-id="element-24">
                {bonus.icon}
              </div>
              <h3 className="text-base font-bold text-white mb-2 leading-tight" data-id="element-25">
                {bonus.title}
              </h3>
              <p className="text-gray-400 mb-4 text-xs leading-relaxed flex-1" data-id="element-26">
                {bonus.description}
              </p>
              <div className="pt-3 border-t border-gray-700" data-id="element-27">
                <p className="text-xs text-gray-500" data-id="element-28">Valor normal:</p>
                <p className="text-lg font-bold text-red-400 line-through decoration-2 decoration-red-500/50" data-id="element-29">
                  {bonus.value}
                </p>
                <p className="text-gold font-bold text-sm mt-0.5" data-id="element-30">
                  HOY: GRATIS
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}